export class OrganisationAddApplication {
  applicationId: number | string;
  constructor() {
    this.applicationId = "";
  }
}
